import { useCallback, useEffect, useState } from 'react';
import { getPacienteInformeById } from '../api/pacientesApi';
import { mapPacienteInformesToRows } from '../utils/pacienteMappers';

export const usePacienteReports = ({ idPaciente }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReports = useCallback(async () => {
    if (!idPaciente) return;
    setLoading(true);
    try {
      const data = await getPacienteInformeById(idPaciente);
      setReports(mapPacienteInformesToRows({ data, idPaciente }));
    } catch (error) {
      console.error('Error fetching reports:', error);
      setReports([]);
    } finally {
      setLoading(false);
    }
  }, [idPaciente]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  return { reports, loading, fetchReports };
};
